import addSoftHyphenation from '@/lib/addSoftHyphenation'
import { StyledFeature } from '@/components/styles'

export default function Feature({ icon, title, description, ...props }) {
  return (
    <StyledFeature {...props}>
      <StyledFeature.Icon>
        <img src={icon} alt={title} />
      </StyledFeature.Icon>
      <StyledFeature.Title>{addSoftHyphenation(title, 18)}</StyledFeature.Title>
      {!!description && <StyledFeature.Text>{description}</StyledFeature.Text>}
    </StyledFeature>
  )
}
